import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Logo from "../components/Logo";
import api from "../lib/api";
import { useI18n } from "../i18n/I18nContext";

export default function VerifyEmail() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("pending"); // pending | ok | fail

  useEffect(() => {
    if (!token) { setState("fail"); return; }
    api.post("/auth/verify-email", { token }).then(() => setState("ok")).catch(() => setState("fail"));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F4F8FC]">
      <div className="w-full max-w-sm text-center df-rise">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <h2 className="font-head text-2xl font-bold text-[#0D253F]">{t("verify_title")}</h2>
        <p className="mt-3 text-[#3B526B]" data-testid="verify-state">
          {state === "pending" && t("verify_pending")}
          {state === "ok" && t("verify_ok")}
          {state === "fail" && t("verify_fail")}
        </p>
        <Link to="/login" className="inline-block mt-6 text-[#1A73E8] font-semibold">{t("login")}</Link>
      </div>
    </div>
  );
}
